import type { Meta, StoryObj } from '@storybook/react';

import { CompletedArea } from './CompletedArea';

const meta: Meta<typeof CompletedArea> = {
  title: 'parts/link button/CompletedArea',
  component: CompletedArea,
  tags: ['autodocs'],
  decorators: [
    Story => (
      <div style={{ padding: '20px' }}>
        <Story />
      </div>
    ),
  ],
};

export default meta;

type Story = StoryObj<typeof CompletedArea>;

export const Basic: Story = {
  args: {
    completedAreas: 0,
    isPrize: false,
  },
};
